import { initSideMenu } from "./components/side-menu";

initSideMenu()

/* Vintage selector */
window.addEventListener("click", e => {
  if (e.target.closest(".selector")) {
    e.target.closest(".selector").classList.toggle("active")
  }
})